import { render, staticRenderFns } from "./NewCurrencySimulation.vue?vue&type=template&id=8603d3f2&scoped=true&"
import script from "./NewCurrencySimulation.vue?vue&type=script&lang=ts&"
export * from "./NewCurrencySimulation.vue?vue&type=script&lang=ts&"
import style0 from "./NewCurrencySimulation.vue?vue&type=style&index=0&id=8603d3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8603d3f2",
  null
  
)

export default component.exports